import type { UpdateWhatsApp } from '@/types/orderUpdates';
import { updateDayKey } from './updatesFormat';

export interface ChatDay {
  key: string;
  at: string;
  messages: UpdateWhatsApp[];
}

/**
 * A chat reads oldest → newest (PRD §5.4). Sort a copy by the wall time — never
 * trust, or mutate, the cached array's order: the API has been seen sending
 * this list oldest first while calls and comments come newest first. Then group
 * consecutive messages by calendar day for the date dividers.
 */
export const toChatDays = (messages: UpdateWhatsApp[]): ChatDay[] =>
  [...messages]
    .sort((a, b) => (a.at === b.at ? 0 : String(a.at) < String(b.at) ? -1 : 1))
    .reduce<ChatDay[]>((days, message) => {
      const key = updateDayKey(message.at);
      const last = days[days.length - 1];
      if (last && last.key === key) last.messages.push(message);
      else days.push({ key, at: message.at, messages: [message] });
      return days;
    }, []);

type Translate = (key: string) => unknown;
const GREY_TICK = 'text-[#8a9a85]';

/** WhatsApp-style receipt for an outgoing message: ✓ sent, grey ✓✓ delivered, blue ✓✓ read. */
export const deliveryTick = (status: UpdateWhatsApp['delivery_status'], t: Translate) =>
  status === 'read'
    ? { mark: '✓✓', label: String(t('updates_status_read')), className: 'text-[#34B7F1]' }
    : status === 'delivered'
      ? { mark: '✓✓', label: String(t('updates_status_delivered')), className: GREY_TICK }
      : status === 'sent'
        ? { mark: '✓', label: String(t('updates_status_sent')), className: GREY_TICK }
        : null;
